import { browser } from '$app/environment';
import { waitLocale } from 'svelte-i18n';
import type { LayoutLoad } from './$types';
import { init, registerLocales } from '$lib/i18n';

// Register locales but don't initialize yet
registerLocales();

export const load: LayoutLoad = async ({ data }) => {
	// Initialize i18n with the correct locale from the server
	init(data.lang);
	if (browser) {
		document.documentElement.lang = data.lang;
	}

	await waitLocale();

	// Return the data to the page component.
	return data;
};
